import { render, staticRenderFns } from "./AddCommonView.vue?vue&type=template&id=008317f4&"
import script from "./AddCommonView.vue?vue&type=script&lang=js&"
export * from "./AddCommonView.vue?vue&type=script&lang=js&"
import style0 from "./AddCommonView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports